(function () {
  function stripEuroInText(root) {
    try {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: (node) => {
            const parent = node.parentNode;
            if (!parent) return NodeFilter.FILTER_REJECT;
            const tag = parent.nodeName;
            if (
              tag === 'SCRIPT' ||
              tag === 'STYLE' ||
              tag === 'NOSCRIPT' ||
              tag === 'TEXTAREA' ||
              tag === 'CODE' ||
              tag === 'PRE' ||
              tag === 'TITLE'
            ) {
              return NodeFilter.FILTER_REJECT;
            }
            if (!node.nodeValue || node.nodeValue.indexOf('€') === -1) {
              return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
          },
        },
        false
      );

      const toUpdate = [];
      while (walker.nextNode()) {
        toUpdate.push(walker.currentNode);
      }
      for (const textNode of toUpdate) {
        textNode.nodeValue = textNode.nodeValue.replace(/\u20AC/g, '');
      }
    } catch (e) {
      // no-op
    }
  }

  function processNode(node) {
    if (!node) return;
    if (node.nodeType === 3) {
      if (node.nodeValue && node.nodeValue.indexOf('€') !== -1) {
        node.nodeValue = node.nodeValue.replace(/\u20AC/g, '');
      }
      return;
    }
    if (node.nodeType !== 1) return;
    const tag = node.nodeName;
    if (
      tag === 'SCRIPT' ||
      tag === 'STYLE' ||
      tag === 'NOSCRIPT' ||
      tag === 'TEXTAREA' ||
      tag === 'CODE' ||
      tag === 'PRE' ||
      tag === 'TITLE'
    )
      return;
    stripEuroInText(node);
  }

  function init() {
    if (!document.body) return;
    processNode(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          m.addedNodes && m.addedNodes.forEach(processNode);
        } else if (m.type === 'characterData') {
          processNode(m.target);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', function () {
      processNode(document.body);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

